goog.provide('el8.ptdata.model.PatientItemSet');

goog.require('el8.model.base');


el8.ptdata.model.PatientItemSet = function(spec) {

    var that = this;
    spec = spec || {};

    spec.loadFn = function(data) {
        that.setDocumented(data.is_documented);
        that.create(data.items, true);
    };
    el8_EntitySet.call(this, spec);
};
el8.ptdata.model.PatientItemSet.inheritsFrom(el8_EntitySet);
el8.ptdata.model.PatientItemSet.prototype.isDocumented = function() {
    // Default to true when not specified (i.e. for PatientItem's that 
    // don't yet have or won't have PatientItemDocumentation subclasses)
    return (this._isDocumented === undefined) ? true : !!this._isDocumented;
};
el8.ptdata.model.PatientItemSet.prototype.setDocumented = function(val) {
    this._isDocumented = !!val;
};

